import React from 'react';
import {
  Field,
} from 'formik';
import { useIntl, defineMessages } from 'react-intl';
import { InputTextComponent, TextAreaComponent } from '../../../components/prime-formik';

const i18nMessages = defineMessages({
  abilityCode: {
    id: 'menu.item-bank-management.ability-code',
    defaultMessage: 'Ability Code',
  },
  abilityDisplayName: {
    id: 'menu.item-bank-management.ability-display-name',
    defaultMessage: 'Ability Display Name',
  },
  abilityDescription: {
    id: 'menu.item-bank-management.ability-description',
    defaultMessage: 'Ability Description',
  },
});

const AbilityData = () => {
  const { formatMessage } = useIntl();

  return (
    <div className="dimension-basic-data-form-controls">
      <div>
        <div className="input-label">{formatMessage(i18nMessages.abilityCode)}</div>
        <div>
          <Field id="code" name="code" component={InputTextComponent} />
        </div>
      </div>
      <div>
        <div className="input-label">{formatMessage(i18nMessages.abilityDisplayName)}</div>
        <div>
          <Field id="displayName" name="displayName" component={InputTextComponent} />
        </div>
      </div>
      <div>
        <div className="input-label">{formatMessage(i18nMessages.abilityDescription)}</div>
        <div>
          <Field id="description" name="description" component={TextAreaComponent} />
        </div>
      </div>
    </div>
  );
};

export default AbilityData;
